var map = {
	"./1.jpg": 3742,
	"./2.jpg": 2409,
	"./3.jpg": 4412,
	"./Copy of Copy of IMG_5870.jpg": 2833,
	"./Copy of Copy of IMG_5876.jpg": 9727
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1416;